import ButtonMinus from '../Buttons/ButtonMinus'
import ButtonPlus from '../Buttons/ButtonPlus'

const Counter = ({
  title = '',
  value = 'null',
  btnMinusDisabled = false,
  btnPlusDisabled = false,
  handleMinus = () => {},
  handlePlus = () => {},
}) => {
  return (
    <div className="counter_component">
      <span className="counter_title">{title}</span>
      <div className="counter_actions">
        <ButtonMinus disabled={btnMinusDisabled} handleMinus={handleMinus} />
        <span className="counter_value">{value}</span>
        <ButtonPlus disabled={btnPlusDisabled} handlePlus={handlePlus} />
      </div>
    </div>
  )
}

export default Counter
